import * as React from "react";
import { Box } from "@mui/material";
import { ActivationInput } from "./ActivationInput";
//import QrReader from 'react-qr-scanner'

import Axios from "axios";
import Button from "@mui/material/Button";

export default function DeviceClaim(props) {
    const [setupName, setSetupName] = React.useState("");
    const [activationCode, setActivationCode] = React.useState("");
    const [delay, setDelay] = React.useState(100);
    const [result, setResult] = React.useState("no result");
    const [serialNumber, setSerialNumber] = React.useState('');
    const [grow_setup, setGrowSetup] = React.useState(props.grow_setup);


    const handleClick = (event) => {
        event.preventDefault();
        if (activationCode.length==19) {
            console.log({ setupName, activationCode });
            Axios.post(`/new_device/`+grow_setup,{data:{serial_number:activationCode},
                headers: {
                    "Access-Control-Allow-Origin": "* ",
                    "Access-Control-Allow-Headers": "Content-Type",
                },
            })
                .then((res) => {

                })
                .catch((err) => console.log(err));
        }
    };

    const handleError = err => {
        console.error(err)
      }

    const handleScan = result => {
        if (result) {
            var x = result.text.substring(result.text.lastIndexOf('/') + 1)
            Axios.post(`/new_device`,{data:{grow_setup:grow_setup,device_hash:x},
                headers: {
                    "Access-Control-Allow-Origin": "* ",
                    "Access-Control-Allow-Headers": "Content-Type",
                },
            })
                .then((res) => {
                    const inputString = res.data.data.key;
                    const regex = /.{4}/g;

                    const chunks = inputString.match(regex);

                    setActivationCode(chunks.join('-'));

                })
                .catch((err) => console.log(err));
        }


      }

    return (
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}}>



                    <label>Serial Number</label>
                    <ActivationInput
                        activationCode={activationCode}
                        onActivationCodeChange={setActivationCode}
                        setSerialNumber = {setSerialNumber}
                        serialNumber = {serialNumber}

                    />
                  <Button variant="contained" color="success" onClick={handleClick}> Hinzufügen</Button>
              </Box>
    );
}